module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/order-or-lot-allocation-methods/order-or-lot-allocation-methods.component.css
// module id = ./src/app/order-or-lot-allocation-methods/order-or-lot-allocation-methods.component.css
// module chunks = main